module.exports = ko;